import { MutableRefObject, useEffect, useState } from 'react'
import useIsMountedRef from 'use-is-mounted-ref'
import { MicrosoftSSOConfigDTO } from '../../../NonReact/Types/Types'
import { getMicrosoftSSOConfig } from '../API/GenericConfigAPI'
import { ReactState } from '../Types/Types'
import { $error } from '../Utils/ConsoleUtils'
import { useFeatureFlag } from './useFeatureFlag'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

export const useMicrosoftSSOConfig = (): Nullable<MicrosoftSSOConfigDTO> => {
    const isMicrosoftSSOEnabled: Definable<boolean> = useFeatureFlag('enableMicrosoftSSO')
    const [microsoftSSOConfig, setMicrosoftSSOConfig]: ReactState<Nullable<MicrosoftSSOConfigDTO>> =
        useState<Nullable<MicrosoftSSOConfigDTO>>(null)

    const isMounted: MutableRefObject<boolean> = useIsMountedRef()

    useEffect((): void => {
        if (isMicrosoftSSOEnabled) {
            getMicrosoftSSOConfig()
                .then((config: JSONResponse<MicrosoftSSOConfigDTO>): void => {
                    if (isMounted.current) {
                        setMicrosoftSSOConfig(config)
                    }
                })
                .catch((): void => {
                    if (isMounted.current) {
                        $error('Failed to get Microsoft SSO config')
                    }
                })
        }
    }, [isMicrosoftSSOEnabled])

    return microsoftSSOConfig
}
